'use client';

import { createInstance, type Resource } from 'i18next';
import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { i18nInit } from './i18nInit';
import type { WebAppName } from './types/WebAppName';

type TranslationsProviderProps = {
  children: React.ReactNode;
  locale: string;
  namespaces: string[];
  resources: Resource;
  appName: WebAppName;
};

export const TranslationsClientProvider: React.FC<TranslationsProviderProps> = ({
  children,
  locale,
  namespaces,
  resources,
  appName,
}) => {
  const i18nInstance = createInstance();
  i18nInit({ locale, namespaces, i18nInstance, resources, appName });
  return <I18nextProvider i18n={i18nInstance}>{children}</I18nextProvider>;
};
